
define('eteration/eteration-async-ajax',['jquery',
        'eteration/lz-string-1.4.4'
    ],
    function ($, lz) {

        var responseArray = [];
        var keys = [];

        function compressEtrAjax(partCount, options, callback, etrAjax) {
            for (var a = 0; a < partCount; a++) {
                getIndexResponse(a, options, callback, etrAjax, partCount);
            }
        }

        function getIndexResponse(index, options, callback, etrAjax, partCount) {
            if (etrAjax === undefined || etrAjax === null) {
                $.ajax({
                    url: toCDNPATH(options.url),
                    dataType: "json",
                    async: true,
                    cache: false,
                    data: {"index": index, "partCount": partCount, "lang":options.lang, "bundles": options.bundles},
                    beforeSend: function (xhr) {
                        xhr.setRequestHeader("Accept-Language", options.lang);
                    },
                    success: function (response) {
                        getCheckControl(callback, response);
                    },
                    error: function (e) {
                        callback(null);
                    }
                });
            } else {
                etrAjax.get({
                    app: 'app.ibs',
                    service: options.url + "?index=" + index,
                    disableLoader: true,
                    callback: function (response) {
                        getCheckControl(callback, response);
                    },
                    error: function (e) {
                        callback(null);
                    }
                });
            }
        }

        function getCheckControl(callback, response) {
            responseArray.push({index: response.index, data: response.value, key:response.key, partCount: response.partCount});
            for(var a = 0;a<responseArray.length;a++){
                if(!keys.includes(responseArray[a].key)){
                    keys[responseArray[a].key] = [];
                }
            }
            for(var a = 0;a<responseArray.length;a++){
                if(!keys.includes(responseArray[a].key)){
                    keys[responseArray[a].key].push({index : responseArray[a].index, data : responseArray[a].data});

                    if(keys[responseArray[a].key].length === responseArray[a].partCount){
                        setCompleteData(keys[responseArray[a].key], callback, responseArray[a].partCount)
                    }
                }
            }
        }
        function setCompleteData(responseArray, callback, partCount){
            try {
                if (responseArray.length !== partCount) return;
                responseArray = sort(responseArray);
                var jsonString = "";
                for (var a = 0; a < responseArray.length; a++) {
                    jsonString += responseArray[a].data;
                }
                jsonString = lz.decompressFromBase64(jsonString);
                var json = JSON.parse(jsonString);
                callback(json);
            }catch (e) {
                callback(null);
            }
        }

        return {
            compressEtrAjax: compressEtrAjax
        };

        function sort(arr){
            for(var i = 0; i < arr.length; i++){
                for(var j = 0; j < arr.length - i - 1; j++){
                    if(arr[j + 1].index < arr[j].index){
                        var temp = arr[j + 1];
                        arr[j + 1] = arr[j];
                        arr[j] = temp;
                    }
                }
            }
            return arr;
        }
    });
